/*eslint no-unused-vars:0 no-trailing-spaces:0 */
/*global sessionStorage */
let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let VenueForm = require("../../widgets/venues/VenueForm");
let FormUtils = require("../../../utils/FormUtils");
let dateformat = require("ES/lib/dateformat");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let esStatusImage = require("../calendar_area/esStatusImage");
let RadioServiceMixin = require("ES/lib/react-pubsub-via-radio.js/RadioServiceMixin");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");
let AuthedUserSession = require("../../../utils/AuthedUserSession");
let getActionListDropDownOptions = require("../../../utils/getActionListDropDownOptions");

let buildGeneralDetailsFields = function (
  Displaylists,
  data,
  canOnlyCreatePersonalEvent
) {
  let fields = {};
  let has_pro = _.includes(
    AuthedUserSession.getSIDsAtPackageLevel("PRO"),
    esUtils.toInt(data.speaker)
  );

  if (_.isEmpty(Displaylists)) {
    return {};
  }
  let my_speakers = FormUtils.getSpeakerNamesBySid(Displaylists, false);
  if (_.size(my_speakers) > 1) {
    fields.speaker = {
      label: "Speaker",
      type: "select",
      options: my_speakers,
    };
  }

  let actionlist_options = getActionListDropDownOptions(
    Displaylists,
    data.speaker,
    _.get(AuthedUserSession, "activeCompany.COMPANY_ID", 2)
  );
  if (actionlist_options) {
    fields.todolists = {
      label: "Action List",
      type: "select",
      placeholder: "-- select actionlist --",
      options: actionlist_options,
      dont_sort_options: false,
      validate:
        AuthedUserSession.is_privatelabel && !canOnlyCreatePersonalEvent
          ? FormUtils.v.required
          : FormUtils.v.optional,
    };
  }

  fields.organization = {
    label: "Presenting to",
    placeholder: "Presenting to",
    validate: FormUtils.v.required,
    type: "text",
  };

  fields.status = {
    label: "Status",
    type: "select",
    options: _.object(
      _.map(
        _.get(Displaylists, ["universal", "eventstatuses"]),
        function (status) {
          return [status.description, status.description];
        }
      )
    ),
    dont_sort_options: true,
    read_only: AuthedUserSession.is_privatelabel && canOnlyCreatePersonalEvent,
    validate(s) {
      if (!AuthedUserSession.is_st_family && s == "lead" && !has_pro) {
        return "Only PRO users can have '" + s + "' events";
      }
      return true;
    },
  };
  fields.personal = {
    label: "Personal/Blackout",
    type: "checkbox",
    read_only: canOnlyCreatePersonalEvent,
  };

  if (AuthedUserSession.is_st_family) {
    fields.pd_rep = {
      label: "PD Rep",
      type: "select",
      placeholder: "none -- direct",
      validate: FormUtils.v.optional,
      options: _.object(
        _.map(_.get(Displaylists, ["sitelists", "pd_reps"]), function (user) {
          return [user.id, user.fullname];
        })
      ),
    };
    fields.sales_rep = {
      label: "Sales Rep",
      type: "select",
      placeholder: "none -- direct",
      validate: FormUtils.v.optional,
      options: _.object(
        _.map(
          _.get(Displaylists, ["sitelists", "sales_reps"]),
          function (user) {
            return [user.id, user.fullname];
          }
        )
      ),
    };
    fields.project_manager = {
      label: "Project Manager",
      type: "select",
      placeholder: "none -- direct",
      validate: FormUtils.v.optional,
      options: _.object(
        _.map(
          _.get(Displaylists, ["sitelists", "project_managers"]),
          function (user) {
            return [user.id, user.fullname];
          }
        )
      ),
    };
  } else {
    fields.bureauID = {
      label: "Bureau",
      type: "select",
      placeholder: "none -- direct",
      validate: FormUtils.v.optional,
      options: _.object(
        _.map(_.get(Displaylists, ["universal", "bureaus"]), function (bureau) {
          return [bureau.bid, bureau.bname];
        })
      ),
    };
    fields.bureauNotes = {
      label: "Bureau Notes",
      type: "text",
      placeholder: "Bureau Notes",
    };
  }
  fields.has_date = {
    label: "(unselect for DATELESS events)",
    type: "checkbox",
  };
  return fields;
};

let buildStagetimeFields = function (Displaylists, data) {
  return {
    description: {
      label: "Description",
      type: "text",
      placeholder: "Description",
      validate: FormUtils.v.optional,
    },
    starttime: {
      label: "Start",
      type: "date",
      placeholder: "Start date and time",
      validate: FormUtils.v.required,
      pick_time: true,
    },
    stoptime: {
      label: "End",
      type: "date",
      placeholder: "End date and time",
      validate: FormUtils.v.required,
      pick_time: true,
      valid_range: {
        start: data.starttime,
      },
    },
    avchecktime: {
      label: "A/V check",
      type: "date",
      placeholder: "A/V check date and time",
      pick_time: true,
      valid_range: {
        stop: data.starttime,
      },
      validate: FormUtils.v.optional,
    },
    room: {
      label: "Room",
      type: "text",
      placeholder: "Room",
      validate: FormUtils.v.optional,
    },
  };
};

let NewForm = dd.createClass({
  mixins: [FormMixin],
  getInitialValuesSourceVersion(props) {
    let url_date = props.url_date;
    return _.isDate(url_date)
      ? esUtils.format_date(url_date, "yyyy-dd-mm")
      : null;
  },
  getInitialValues(props) {
    let Displaylists = props.Displaylists;
    let lastSelectedSID = AuthedUserSession.getLastSelectedSID();
    let sid =
      lastSelectedSID ||
      _.first(_.map(_.get(Displaylists, "perspeaker"), "sid"));
    let canOnlyCreatePersonalEvent =
      !AuthedUserSession.doIHaveAccess.full.any(sid); //as for speaker users on a privatelabel who can only create blackout events

    let data = {
      speaker: sid + "",
      has_date: true,
      todolists: sid + "|0",
      status: AuthedUserSession.is_st
        ? canOnlyCreatePersonalEvent
          ? "confirmed"
          : "lead"
        : "held", //CS SPKR-users create as HELD, ST SPKR-users create as CONFIRMED
      country: "US",
      personal: canOnlyCreatePersonalEvent,
    };
    if (_.isDate(props.url_date)) {
      data.starttime = props.url_date;
      data.stoptime = props.url_date;
    }

    if (AuthedUserSession.is_privatelabel) {
      //TEAM-ADMIN privatelabels using only common actionlists
      data.todolists = null;
    }

    // set default values if we have them available from the mother event
    if (
      this.props.has_parent &&
      sessionStorage.getItem("parent_organization")
    ) {
      data.organization = sessionStorage.getItem("parent_organization");
      data.status = sessionStorage.getItem("parent_status");
      data.pd_rep = sessionStorage.getItem("parent_pd_rep_id");
      data.sales_rep = sessionStorage.getItem("parent_sales_rep_id");
      data.project_manager = sessionStorage.getItem(
        "parent_project_manager_id"
      );
      data.bureauID = sessionStorage.getItem("parent_bureauID");
      data.bureauNotes = sessionStorage.getItem("parent_bureauNotes");
      const parent_sid = JSON.parse(sessionStorage.getItem("parent_sids"))[0];
      if (parent_sid > 0) {
        data.speaker = parent_sid;
      }
      const venue = JSON.parse(sessionStorage.getItem("parent_Venue"))[0];
      _.each(venue, function (value, key) {
        data[key] = value;
      });
    }

    return data;
  },

  buildSchema(props) {
    let Displaylists = (props || this.props).Displaylists;
    let data = _.get(this, "state.data", {});
    let canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(
      data.speaker
    ); //as for speaker users on a privatelabel who can only create blackout events
    let detail_fields = buildGeneralDetailsFields(
      Displaylists,
      data,
      canOnlyCreatePersonalEvent
    );
    let stagetime_fields = !data.has_date
      ? null
      : buildStagetimeFields(Displaylists, data);
    let venue_fields = VenueForm.buildFields(Displaylists, data);
    return _.assign(detail_fields, stagetime_fields, venue_fields);
  },

  onFormChanged(field_path, new_value) {
    let self = this;
    let data = (this.state && this.state.data) || {};
    if (field_path === "starttime" && _.isDate(new_value)) {
      this.setState({ data: data }, function () {
        if (
          !_.isDate(data.stoptime) ||
          data.stoptime.getTime() < new_value.getTime()
        ) {
          self.Form_onChange("stoptime", _.cloneDeep(new_value));
        }
      });
    }
  },
  render() {
    let self = this;
    let fields = this.Form_buildSchema();
    let data = this.state.data || {};
    let { onCancel } = this.props;

    let canOnlyCreatePersonalEvent = !AuthedUserSession.doIHaveAccess.full.any(
      data.speaker
    ); //as for speaker users on a privatelabel who can only create blackout events
    // let errorMessage = _.reduce(_.get(this.state, "errors", {}), function (result, v, k) {
    //   (result || (result = [])).push(v + " on " + k.toUpperCase()+".");
    //   return result;
    // }, []);
    // errorMessage = errorMessage.join(" ");
    const errorMessage = !_.isEmpty(_.get(this.state, "errors"))
      ? "Fix errors above to continue."
      : null;
    let renderFieldLayout = function (layout) {
      return ezHorizontalFields(
        self,
        _.filter(layout, function (row) {
          return _.size(row) === 1 ? _.has(fields, row[0]) : true;
        }),
        "sm",
        2
      );
    };

    let middlesection = AuthedUserSession.is_st_family
      ? renderFieldLayout([["pd_rep"], ["sales_rep"], ["project_manager"]])
      : renderFieldLayout([["bureauID"], ["bureauNotes"]]);
    if (AuthedUserSession.is_privatelabel && canOnlyCreatePersonalEvent) {
      middlesection = null;
    }

    return dd.form(
      { className: "form-horizontal", onSubmit: this.Form_onSubmit },
      dd.h4({ className: "section-head" }, "Event Details"),
      renderFieldLayout([
        ["speaker"],
        !AuthedUserSession.is_privatelabel || !canOnlyCreatePersonalEvent
          ? ["todolists"]
          : null,
        ["organization"],
        ["status", "personal"],
      ]),
      middlesection,
      renderFieldLayout([["has_date"]]),
      !data.has_date ? null : dd.h4({ className: "section-head" }, "Stagetime"),
      !data.has_date
        ? null
        : renderFieldLayout([
            ["description"],
            ["starttime"],
            ["stoptime"],
            ["avchecktime"],
            ["room"],
          ]),
      dd.h4({ className: "section-head" }, "Venue"),
      renderFieldLayout(VenueForm.horizontal_fields_layout),
      dd.div(
        { className: "form-group text-center", style: { marginTop: 30 } },
        !_.isEmpty(errorMessage) &&
          dd.div(
            {
              className: "has-error",
              style: { marginRight: "2rem", marginLeft: "2rem" },
            },
            dd.p({ className: "help-block" }, errorMessage)
          ),
        dd.button(
          { type: "submit", className: "btn btn-primary btn-lg" },
          "Create Event"
        ),
        " ",
        dd.button(
          { className: "btn btn-default btn-lg", onClick: onCancel },
          "Cancel"
        )
      )
    );
  },
});

module.exports = dd.createClass({
  mixins: [RadioServiceMixin],
  RadioService_setup() {
    return {
      Event_my_events_on_date: {
        key: "callService",
        on: {
          succeeded(data) {
            if (_.size(data) === 0) {
              this.__saveTheEvent();
            }
          },
          failed(error) {
            //ignore this error b/c it's not a big deal
            this.__saveTheEvent();
          },
        },
      },
    };
  },
  getInitialState() {
    return { event_to_save: null, date_to_check_first: null };
  },
  __saveTheEvent: esUtils.wrapPreventDefault(function () {
    radio("save_Event").broadcast(this.state.event_to_save);
    this.setState({
      event_to_save: null,
      date_to_check_first: null,
      Event_my_events_on_date: {},
    });
  }),
  __dontSaveTheEvent: esUtils.wrapPreventDefault(function () {
    this.setState({
      event_to_save: null,
      date_to_check_first: null,
      Event_my_events_on_date: {},
    });
  }),
  __onSubmit(data) {
    let event = {
      eid: 0,
      sids: [esUtils.toInt(data.speaker)],
      parentID: Math.max(0, esUtils.toInt(this.__parseUrlParams().parent_id)),
      organization: data.organization,
      status: data.status,
      isPersonal: !!data.personal,
      pd_rep_id: esUtils.toInt(_.get(data, ["pd_rep"], 0)),
      sales_rep_id: esUtils.toInt(_.get(data, ["sales_rep"], 0)),
      project_manager_id: esUtils.toInt(_.get(data, ["project_manager"], 0)),
      bureauID: esUtils.toInt(_.get(data, ["bureauID"], 0)),
      bureauNotes: _.get(data, ["bureauNotes"], 0),
      companyID: _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]),
      todolistids: [],
    };
    if (!esUtils.isBlank(data.todolists)) {
      event.todolistids = [_.parseInt(data.todolists)]; //must be integers
    }
    if (event.sids[0] > 0) {
      AuthedUserSession.setLastSelectedSID(event.sids[0]);
    }

    if (data.has_date) {
      event.Stagetime = [
        {
          id: 0,
          description: data.description,
          starttime: data.starttime,
          stoptime: data.stoptime,
          avchecktime: data.avchecktime,
          room: data.room,
        },
      ];
    }
    event.Venue = [
      {
        id: 0,
        address: data.address,
        building: data.building,
        city: data.city,
        country: data.country,
        fax: data.fax,
        phone: data.phone,
        st: data.st,
        timezone: data.timezone,
        zip: data.zip,
      },
    ];
    let self = this;
    this.setState(
      {
        event_to_save: event,
        date_to_check_first:
          data.has_date && _.isDate(data.starttime) ? data.starttime : null,
      },
      function () {
        if (_.isDate(self.state.date_to_check_first)) {
          this.RadioService_callService("Event_my_events_on_date", {
            "yyyy-mm-dd": dateformat(
              self.state.date_to_check_first,
              "yyyy-mm-dd"
            ),
            speaker_ids: self.state.event_to_save.sids,
          });
        } else {
          this.__saveTheEvent();
        }
      }
    );
  },
  __openEvent(event_id) {
    return esUtils.wrapPreventDefault(function () {
      radio("Hashbang_set").broadcast("/events/" + event_id);
    });
  },
  __cancel: esUtils.wrapPreventDefault(function () {
    radio("Hashbang_set").broadcast("");
  }),
  __parseUrlParams() {
    let { url_params } = this.props;
    let r = {
      date: null,
      parent_id: 0,
    };
    if (/^\s*[0-9]+\-[0-9]+\-[0-9]+\s*$/.test(url_params[0])) {
      let [y, m, d] = url_params[0].split("-");
      r.date = new Date(
        esUtils.toInt(y),
        esUtils.toInt(m) - 1,
        esUtils.toInt(d)
      );
    } else if (url_params[0] === "child") {
      r.parent_id = esUtils.toInt(url_params[1]);
    }
    return r;
  },
  render() {
    let { Displaylists } = this.props;
    let ajax = this.state.Event_my_events_on_date;
    let events = ajax.data;

    return dd.div(
      { className: "NewEventForm panel panel-default", style: { margin: 10 } },
      dd.div(
        { className: "panel-body" },
        LoadingWrap(
          { is_loading: ajax.waiting, glass: true },
          dd.h2(
            { style: { margin: "0 0 15px 0", textAlign: "center" } },
            "Creating New Event"
          ),
          NewForm({
            Displaylists,
            url_date: this.__parseUrlParams().date,
            onSubmit: this.__onSubmit,
            onCancel: this.__cancel,
            has_parent: this.__parseUrlParams().parent_id > 0 ? true : false,
          })
        )
      ),
      _.size(events) > 0
        ? Modal(
            {
              title: "Are you sure?",
              onClose: this.__dontSaveTheEvent,
              buttons: [
                {
                  name: "Yes",
                  onClick: this.__saveTheEvent,
                  className: "btn btn-default",
                },
                {
                  name: "No",
                  onClick: this.__dontSaveTheEvent,
                  className: "btn btn-default",
                },
              ],
            },
            dd.p(
              null,
              _.size(events) === 1
                ? dd.span(null, "There is one event on ")
                : dd.span(null, "There are ", _.size(events), " events on "),
              dateformat(this.state.date_to_check_first, "dddd, mmmm d, yyyy"),
              "."
            ),
            dd.div(
              { style: { margin: "1em 0 1em 1em" } },
              _.map(
                events,
                function (event) {
                  return dd.div(
                    {
                      key: event.eid,
                      style: { marginBottom: 10, lineHeight: "28px" },
                      className: "clickable",
                      onClick: this.__openEvent(event.eid),
                    },
                    dd.div(
                      { className: "pull-left", style: { marginRight: 10 } },
                      esStatusImage({
                        status: event.eventconfirmed,
                        delivery_method: event.deliverymethod,
                        has_parent: event.parentid > 0,
                        has_children: event.n_children > 0,
                        size: 30,
                      })
                    ),
                    dd.div(
                      null,
                      event.organization,
                      " ",
                      event.meetingname,
                      " ",
                      event.ispersonal ? "(personal)" : ""
                    ),
                    dd.div({ className: "clearfix" })
                  );
                },
                this
              )
            ),
            dd.div(null, "Do you still want to create your event on this date?")
          )
        : null
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/NewEventForm.js